<script>
import CompanyTabLayout from '@/components/company/CompanyTabLayout.vue';
import RushesList from '@/pages/rushes/RushesList.vue';

export default {
  components: {
    CompanyTabLayout,
    RushesList,
  },
};
</script>

<template>
  <CompanyTabLayout active-tab="processing" v-slot="{ companyId }">
    <RushesList :company-id="companyId" />
  </CompanyTabLayout>
</template>
